<template>
  <div>
    <ServiceRequestCreate ref="serviceRequestCreate" :policy="policy" :serviceRequestType="serviceRequestKey" :initialID="ID" @onDataRetrived="onDataRetrived">
      <div slot="serviceRequestType" slot-scope="row">
        <div v-if="!row.status || row.status === 'PEN'">
          <FITTextInput :rule="{required:true, decimal:true}" field="modalPremium" :label="getLabel('modalPremium')" v-model="form.modalPremium" type="number" :width="columnWidth" :disabled="row.isLocked"></FITTextInput>
        </div>
        <div v-else>
          <ServiceRequestDetailRow :field="getLabel('modalPremium')" :value="form.modalPremium"></ServiceRequestDetailRow>
        </div>
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'
import ServiceRequestDetailRow from '../ServiceRequestDetailRow'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'ChangePolicyBenefit',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea,
    ServiceRequestDetailRow
  },

  methods: {
    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    },

    onDataRetrived(data) {
      this.selectedType.list
        .forEach((column) => {
          Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
        })
    }
  },

  data() {
    return {
      type: {},
      form: {
        ID: this.policy.policyID,
        modalPremium: 0
      },
      serviceRequestKey: 'CPB'
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      default: null
    }
  },

  computed: {
    columnWidth() {
      if (this.$refs.serviceRequestCreate) {
        return this.$refs.serviceRequestCreate.option.data.column;
      }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType'
    ]),

  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }

    // this.$store.dispatch('ServiceRequest/getFields', {
    //     type: this.serviceRequestKey,
    //     ...this.policy
    //   })
    //   .then((json) => {
    //     this.selectedType.list
    //       .forEach((column) => {
    //         Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
    //       })
    //   })
    //   .catch((err) => {

    //   })
  },

  watch: {
    form: {
      deep: true,
      handler(val) {
        console.debug(val);
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: JSON.parse(JSON.stringify(val))
        })
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/ChangePolicyBenefit.vue